import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store';


const SW_UPDATE_TOAST_ID = 'sw-update-toast';

const notifyServiceWorkerUpdate = (registration: ServiceWorkerRegistration) => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    if (document.getElementById(SW_UPDATE_TOAST_ID)) {
        return;
    }

    const overlay = document.createElement('div');
    overlay.id = SW_UPDATE_TOAST_ID;

    Object.assign(overlay.style, {
        position: 'fixed',
        inset: '0',
        zIndex: '99999',
        background: 'rgba(0, 0, 0, 0.45)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        boxSizing: 'border-box',
    });

    const toast = document.createElement('div');

    Object.assign(toast.style, {
        width: '100%',
        maxWidth: '420px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '16px',
        borderRadius: '12px',
        background: '#111827',
        color: '#F9FAFB',
        boxShadow: '0 12px 24px rgba(17,24,39,0.35)',
        fontSize: '14px',
        lineHeight: '1.4',
    });

    const messageWrapper = document.createElement('div');
    messageWrapper.style.flex = '1 1 auto';

    const title = document.createElement('div');
    title.textContent = '🚀 Có bản cập nhật mới';
    Object.assign(title.style, {
        fontWeight: '600',
        marginBottom: '4px',
    });

    const message = document.createElement('div');
    message.textContent =
        'Ứng dụng đã được cập nhật. Vui lòng tải lại để tiếp tục sử dụng.';

    Object.assign(message.style, {
        color: '#D1D5DB',
    });

    messageWrapper.append(title, message);

    const refreshButton = document.createElement('button');
    refreshButton.type = 'button';
    refreshButton.textContent = 'Tải lại';

    Object.assign(refreshButton.style, {
        border: '0',
        padding: '10px 14px',
        borderRadius: '8px',
        fontWeight: '600',
        cursor: 'pointer',
        flexShrink: '0',
        whiteSpace: 'nowrap',
        background: '#22C55E',
        color: '#052E16',
    });

    refreshButton.onclick = () => {
        refreshButton.disabled = true;
        refreshButton.textContent = 'Đang tải...';
        serviceWorkerRegistration.applyServiceWorkerUpdate(registration);
    };

    toast.append(messageWrapper, refreshButton);
    overlay.appendChild(toast);
    document.body.appendChild(overlay);

    // Khóa toàn bộ thao tác phía sau
    document.body.style.overflow = 'hidden';
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <App/>
            </BrowserRouter>
        </React.StrictMode>
    </Provider>
);

// Register the service worker for offline capabilities.
// Learn more about service workers: https://cra.link/PWA
try {
    serviceWorkerRegistration.register({
        onUpdate: notifyServiceWorkerUpdate,
    });
} catch (error) {
    console.error('Service worker registration failed:', error);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
